export default "__VITE_ASSET__zXsBeMOb__"